import { FREE_SHIPPING_THRESHOLD } from './constants'

export const DIRECT_FLAT_FEE = 55

export const shippingFee = (subtotal) => {
  if (subtotal > FREE_SHIPPING_THRESHOLD) return 0
  return DIRECT_FLAT_FEE
}

export const getShippingDetails = (addr) => {
  return `${addr.address}, ${addr.city}, ${addr.province}, ${addr.postalCode}`
}
